import { IonCol, IonContent, IonGrid, IonPage } from '@ionic/react';
import React from 'react';

import ContentGradient from '@/components/@ionic/ContentGradient';
import Header from '@/components/@ionic/Header';
import IonicPageWrapper from '@/components/@ionic/IonicPageWrapper';

import S from './BasePage.styles';

interface Props {
  children: React.ReactNode;
}

const BasePage: React.FC<Props> = ({ children }) => (
  <IonicPageWrapper>
    <IonPage>
      <IonContent>
        <ContentGradient />

        <IonGrid>
          <S.HeaderIonRow>
            <IonCol>
              <Header />
            </IonCol>
          </S.HeaderIonRow>

          {children}
        </IonGrid>
      </IonContent>
    </IonPage>
  </IonicPageWrapper>
);

export default BasePage;
